import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { TaggableNamed } from '../base/taggable-named';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { CredentialType } from './credential-constants';
import { ValidationConstants } from '../../shared/validation-constants';
import { CredentialTypeOptions } from './credential-options';
import { CredentialProperties } from './credential-properties';
import { ModelConstants } from '../model-constants';
import { ActionConstants } from '../../constants/action-constants';
import { ServicePrincipalCredentialProperties } from './serviceprincipal-credential-properties';
import { FederatedIdentityCredentialProperties } from './federated-identity-credential-properties';

@Metamodel.model({
    name: 'credential',
    display: [shellStringResources.Credential, shellStringResources.Credentials],
    referable: true,
    reusable: true,
    constraints: {
        name: {
            required: true,
            pattern: ValidationConstants.factoryEntityNoSpaceNameValidator
        }
    },
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.credentialsWrite
        },
        deleteResource: {
            action: ActionConstants.credentialsDelete
        }
    }
})
export class Credential extends TaggableNamed {

    public static readonly MODEL: IModel;

    public properties: CredentialProperties;

    public isUxModel: boolean;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public getType(): CredentialType {
        const propertyModelName = Metamodel.modelOf(this.properties).name;
        switch (propertyModelName) {
            case ModelConstants.servicePrincipalCredentialProperties:
                return CredentialTypeOptions.ServicePrincipal;
            case ModelConstants.managedIdentityCredentialProperties:
                return CredentialTypeOptions.ManagedIdentity;
            case ModelConstants.userAssignedManagedIdentityCredentialProperties:
                return CredentialTypeOptions.UserAssignedManagedIdentity;
            case ModelConstants.userAuthCredentialProperties:
                return CredentialTypeOptions.UserAuth;
            case ModelConstants.emailCredentialProperties:
                return CredentialTypeOptions.EmailAuth;
            case ModelConstants.teamsCredentialProperties:
                    return CredentialTypeOptions.TeamsAuth;
            case ModelConstants.azureBlobCredentialProperties:
                return CredentialTypeOptions.AzureBlobAuth;
            case ModelConstants.azureDevopsCredentialProperties:
                return CredentialTypeOptions.AzureDevopsAuth;
            case ModelConstants.azureDataFactoryCredentialProperties:
                return CredentialTypeOptions.AzureDataFactoryAuth;
            default:
                return 'Unknown';
        }
    }

    public get isFic(): boolean {
        return this.getType() === CredentialTypeOptions.ServicePrincipal &&
            (this.properties as ServicePrincipalCredentialProperties)?.servicePrincipalKey instanceof FederatedIdentityCredentialProperties;
    }

    // returns true for all credentials that don't contain token (SAMI, UAMI, SPN).
    public isCredentialWithoutToken(): boolean {
        return (this.getType() !== CredentialTypeOptions.UserAuth);
    }
}
